module.exports = __webpack_public_path__ + "static/media/Dr_Enrique_Diaz_Aranda.6147bbf5.jpg";